// This type is designated for policy coverage that were provided by partners or entered by agent manually via UI,
// or quotes

export enum PolicyCoverageKey {
  Dwelling = 'dwelling',
  OtherStructures = 'other_structures',
  PersonalProperty = 'personal_property',
  LossOfUse = 'loss_of_use',
  PersonalLiability = 'personal_liability',
  MedicalPayments = 'medical_payments',

  Hurricane = 'hurricane',
  WindHail = 'wind_hail',
  WaterBackup = 'water_backup',
  Earthquake = 'earthquake',
  Flood = 'flood',
  Wildfire = 'wildfire',

  HouseholdFurnishings = 'household_furnishings',
  FairRentalValue = 'fair_rental_value',
  ServiceLine = 'service_line',
  EquipmentBreakdown = 'equipment_breakdown',
  Foundation = 'foundation',
  WaterDamage = 'water_damage',

  ExtendedReplacementCost = 'extended_replacement_cost',
  ReplacementCostOnContents = 'replacement_cost_on_contents',
  FunctionalReplacementCost = 'functional_replacement_cost',

  BiPerPerson = 'bodily_injury_per_person',
  BiPerAccident = 'bodily_injury_per_accident',
  PropertyDamage = 'property_damage',
  UninsuredMpd = 'uninsured_motorist_property_damage',
  UninsuredMbiPerPerson = 'uninsured_motorist_bodily_injury_per_person',
  UninsuredMbiPerAccident = 'uninsured_motorist_bodily_injury_per_accident',
  UnderinsuredMbiPerPerson = 'underinsured_motorist_bodily_injury_per_person',
  UnderinsuredMbiPerAccident = 'underinsured_motorist_bodily_injury_per_accident',
  Comprehensive = 'comprehensive',
  Collision = 'collision',
  Towing = 'towing',
  FullGlass = 'full_glass',
  RentalPerDay = 'rental_per_day',
  RentalMaxAmount = 'rental_max_amount',
  PersonalInjuryProtection = 'personal_injury_protection',
  UninsuredStacking = 'uninsured_stacking',
  UnderInsuredStacking = 'underinsured_stacking',
  RoadsideAssistance = 'roadside_assistance',
  Ridesharing = 'ridesharing',
  LeaseGap = 'lease_gap',
  CoastalNavigation = 'coastal_navigation',
  TrailerCoverage = 'trailer_coverage',
  Disappearing = 'disappearing_deductible',
  FuelAndOilSpill = 'fuel_and_oil_spill',
  ActualCash = 'actual_cash_value',
  OnWaterTowing = 'on_water_towing',
  HurricaneHaulOut = 'hurricane_haul_out',

  Jewelry = 'jewelry',
  AccidentAndIllness = 'accident_and_illness',
  FaceAmount = 'face_amount'
}

export const PERCENTAGE_COVERAGES = [PolicyCoverageKey.ExtendedReplacementCost];
export const BOOLEAN_COVERAGES = [
  PolicyCoverageKey.Foundation,
  PolicyCoverageKey.FunctionalReplacementCost,
  PolicyCoverageKey.ReplacementCostOnContents,
  PolicyCoverageKey.UnderInsuredStacking,
  PolicyCoverageKey.UninsuredStacking,
  PolicyCoverageKey.RoadsideAssistance,
  PolicyCoverageKey.Ridesharing,
  PolicyCoverageKey.LeaseGap,
  PolicyCoverageKey.CoastalNavigation,
  PolicyCoverageKey.TrailerCoverage,
  PolicyCoverageKey.WaterDamage,
  PolicyCoverageKey.Disappearing,
  PolicyCoverageKey.FuelAndOilSpill,
  PolicyCoverageKey.ActualCash,
  PolicyCoverageKey.OnWaterTowing,
  PolicyCoverageKey.HurricaneHaulOut
];

export const DEDUCTIBLE_COVERAGES = [
  PolicyCoverageKey.WindHail,
  PolicyCoverageKey.Hurricane,
  PolicyCoverageKey.Collision,
  PolicyCoverageKey.Comprehensive,
  PolicyCoverageKey.Towing,
  PolicyCoverageKey.RentalMaxAmount,
  PolicyCoverageKey.RentalPerDay,
  PolicyCoverageKey.Wildfire
];

export enum LimitType {
  MoneyLimit = 'money_limit',
  MonthlyLimit = 'monthly',
  OtherLimit = 'other'
}

export enum DeductibleType {
  Flat = 'flat',
  Percentage = 'percentage'
}

export interface PolicyCoverage {
  gid: string;
  key: PolicyCoverageKey;
  limit_type: LimitType;
  limit_value: string;
  deductible_type: DeductibleType | null;
  deductible_value: string | null;
}

export const coverageByKey = <T extends { key: string }>(coverages: T[] | null | undefined, key: PolicyCoverageKey) =>
  coverages?.find(coverage => key === coverage.key);
